import QRCode from "react-qr-code";
import { useEffect, useState } from "react";
import { Brboxiconbtn } from "../../../components/btns/brboxiconbtn";

const QrInfo = ({ isOpen, name, description, link, close }) => {
    useEffect(() => {
        const modal = document.querySelector(".qr-modal-container");

        if (modal == null) return

        const OPEN = "open";
        const CLOSE = "close";
        const CLOSING = "closing";

        if (isOpen) {
            modal.classList.remove(CLOSE)
            modal.classList.add(OPEN)
        } else {
            modal.classList.add(CLOSING);
            modal.addEventListener("animationend", () => {
                modal.classList.remove(OPEN)
                modal.classList.remove(CLOSING)
                modal.classList.add(CLOSE);
            }, { once: true })
        }

    }, [isOpen])

    const copyLink = () => {
        navigator.clipboard.writeText("https://sign-card.com/profile/" + link);
    }

    return (
        <div className="qr-modal-container">
            <div className="qr-overay"></div>
            <div className="qr-container">
                <button className="qr-close-btn" onClick={close}>
                    <img src="/assets/icons/cancel.svg" />
                </button>

                <div className="user-info">
                    <h3 className="user-name">{name}</h3>
                    <span className="user-desc hidden">{description}</span>
                </div>
                <div className={"qr-wrapper"}>
                    <QRCode value={window.location.href} className="qr-code" />
                </div>
                <div className="notice">
                    <i>
                        <img alt={""} src="/assets/icons/notice.svg" />
                    </i>
                    <p className="desc">
                        카메라로 인식하여<br />
                        Sign Card로 이동할 수 있어요
                    </p>
                </div>

            </div>
            <div className='profile-btn-container'>
                <button type="submit" className={`profile-btn purple`} onClick={copyLink}>
                    <span className="profile-btn-text">링크복사</span>
                    <div className="profile-icon-wrapper">
                        <img src={`/assets/icons/link.svg`} />
                    </div>
                </button>
            </div>
        </div>
    )
}

export default QrInfo 